import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AgenteService } from '../../services/agente/agente.service';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class InicioGuardService implements CanActivate {

  constructor(private agenteService: AgenteService, private cookieService: CookieService) { }

  private acceso = false;

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    this.agregarTokenHomeNew();
    this.agregarTokenPanama();
    return this.agenteService.cargarPerfil().then((data) => {
      let acceso = false;
      if (data !== null) {
        acceso = true;
      }
      return acceso;

    }, (error) => {
      return false;
    });
  }

  agregarTokenPanama() {
    if (window.location.href.toUpperCase().includes('COUNTRY=PA')) {
      this.cookieService.put('CodCountry', btoa('P'), { domain: 'sura.com' });
    }
  }


  agregarTokenHomeNew() {
    this.cookieService.put('HomeNew', btoa('S'), { domain: 'sura.com' });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/inicio-guard/inicio-guard.service.ts